import Layout from "../components/Layout";
import React, {useEffect, useRef, useState} from "react";
import AssessmentInfoCard from "../components/AssessmentInfoCard";
import {useSearchParams} from "react-router-dom";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";


const MarksSummary = () => {
    const [searchParams] = useSearchParams()
    const [userAssessmentInfo, setUserAssessmentInfo] = useState([]);
    const [userCompetencyInfo, setUserCompetencyInfo] = useState([]);
    const [userMatrixData, setUserMatrixData] = useState([]);
    const [employeeDetails, setEmployeeDetails] = useState([])
    //const { user } = useSelector((state) => state["auth"]);
    //const [filters, setFilters] = useState(null);
    //const [globalFilterValue, setGlobalFilterValue] = useState('');

    useEffect(() => {
        if (searchParams.has("employeeId")) {
            //initFilters();
            //console.log(atob(searchParams.get("employeeId")));
            //console.log(atob(searchParams.get("quarterID")));
            const P_employeeId = atob(searchParams.get("employeeId"));
            const P_QuarterID = atob(searchParams.get("quarterID"));
            userAssessmentInformation(P_employeeId,P_QuarterID);
            userCompetencyInformation(P_employeeId,P_QuarterID);
            GetIDPEmployeeDetails(P_employeeId,P_QuarterID);
            getUserMatrixData(P_employeeId,P_QuarterID)
        }
        else{
            console.log("No Data Found");
        }
    }, [])

    const GetIDPEmployeeDetails = (id,qID) => {
        const data = {
            RegisterID: id,
            QuarterID : parseInt(qID)
        }
        axios.post(BASE_URL + `/api/EmployeeMatrix/GetSelectedEmployeeDetails`, JSON.stringify(data))
            .then(response => {
                setEmployeeDetails(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    // const onGlobalFilterChange = (e) => {
    //     const value = e.target.value;
    //     let _filters1 = {...filters};
    //     _filters1['global'].value = value;
    //     setFilters(_filters1);
    //     setGlobalFilterValue(value);
    // }


    // const initFilters = () => {
    //     setFilters({
    //         'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    //         'employeeName': {
    //             operator: FilterOperator.AND,
    //             constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
    //         },
    //         'department': {
    //             operator: FilterOperator.AND,
    //             constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
    //         },
    //         'designation': {
    //             operator: FilterOperator.AND,
    //             constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
    //         },
    //     });
    //     setGlobalFilterValue('');
    // }
    // const clearFilter = () => {
    //     initFilters();
    // }

    const getUserMatrixData = (registerId,qID) =>{
        const data = {
            RegisterID: registerId,
            QuarterID : parseInt(qID)
        }
        axios
            .post(BASE_URL + "/api/EmployeeMatrix/GetUserMatrixData/", JSON.stringify(data))
            .then((response) => {
                if (response.status === 200) {
                    setUserMatrixData(response.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    const userAssessmentInformation = (id,qID) => {
        const data = {
            RegisterID: id,
            QuarterID : parseInt(qID)
        }
        axios
            .post(BASE_URL + "/api/utility/UserAssesmentInfromation/", JSON.stringify(data))
            .then((response) => {
                if (response.status === 200) {
                    setUserAssessmentInfo(response.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const userCompetencyInformation = (id,qID) => {
        const data = {
            RegisterID: id,
            QuarterID : parseInt(qID)
        }

        axios
            .post(BASE_URL + "/api/utility/UserCompetencyInfromation/", JSON.stringify(data))
            .then((response) => {
                if (response.status === 200) {
                    setUserCompetencyInfo(response.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };
    return (
      <Layout>
          <div className="card mb-3">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-4">
                          <b> Name:</b> {employeeDetails.length !== 0 ? employeeDetails[0].employeeName : ""}
                        </div>
                        <div className="col-md-3">
                        <b>Designation:</b> {employeeDetails.length !== 0 ? employeeDetails[0].designation : ""}
                        </div>
                        <div className="col-md-5">
                        <b>Department:</b> {employeeDetails.length !== 0 ? employeeDetails[0].department : ""}
                        </div>
                    </div>
                </div>
            </div>
          <AssessmentInfoCard
              title={<span style={{ color: "#FFA500", textTransform: "uppercase" }}>
                <b>CORE VALUES</b>
              </span>}
              smallTitle={""}>
              <table className="table">
                  <thead>
                  <tr>
                      <th scope="col" className="tdHeaderGroupStart" colSpan={2}>Values</th>
                      <th scope="col" className="tdHeaderGroup" colSpan={3}>Self</th>
                      <th scope="col" className="tdHeaderGroupEnd" colSpan={3}>Supervisor</th>
                  </tr>
                  <tr>
                      <th scope="col">Name</th>
                      <th scope="col" className="tdHeaderGroup">RCA</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                  </tr>
                  </thead>
                  <tbody>
                  {userAssessmentInfo.map((value, index) => (
                      <tr key={index}>
                          <td>{value.assestmentName}</td>
                          <td className="tdWhiteSpace tdCenter">{value.rca}</td>
                          <td>{value.selfOpinion}</td>
                          <td className="tdCenter">{value.selfAssesmentMark}</td>
                          <td className="tdCenter">{value.selfGap}</td>
                          <td>{value.supervisorOpinion}</td>
                          <td className="tdCenter">{value.supervisorAssesmentMark}</td>
                          <td className="tdCenter">{value.supervisorGap}</td>
                      </tr>
                  ))}
                  <tr>
                      <td colSpan={3} className="tdCenter"><b>Total</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.selfAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.selfGap)).reduce((prev, next) => prev + next)}</b></td>
                      <td/>
                      <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.supervisorAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.supervisorGap)).reduce((prev, next) => prev + next)}</b></td>
                  </tr>
                  </tbody>
              </table>
          </AssessmentInfoCard>


          <AssessmentInfoCard
              title={
                  <span style={{ color: "#eb4034", textTransform: "uppercase" }}>
                <b>Core Competency</b>
              </span>
              }
              smallTitle={""}>
              <table className="table">
                  <thead>
                  <tr>
                      <th scope="col" className="tdHeaderGroupStart" colSpan={2}>Competency</th>
                      <th scope="col" className="tdHeaderGroup" colSpan={3}>Self</th>
                      <th scope="col" className="tdHeaderGroupEnd" colSpan={3}>Supervisor</th>
                  </tr>
                  <tr>
                      <th scope="col">Name</th>
                      <th scope="col" className="tdHeaderGroup">RCA</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                  </tr>
                  </thead>
                  <tbody>
                  {userCompetencyInfo.map((value, index) => (
                      <tr key={index}>
                          <td>{value.competencyName}</td>
                          <td className="tdWhiteSpace tdCenter">{value.rca}</td>
                          <td>{value.selfOpinion}</td>
                          <td className="tdCenter">{value.selfAssesmentMark}</td>
                          <td className="tdCenter">{value.selfGap}</td>
                          <td>{value.supervisorOpinion}</td>
                          <td className="tdCenter">{value.supervisorAssesmentMark}</td>
                          <td className="tdCenter">{value.supervisorGap}</td>
                      </tr>
                  ))}
                  <tr>
                      <td colSpan={3} className="tdCenter"><b>Total</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.selfAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.selfGap)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1}/>
                      <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.supervisorAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.supervisorGap)).reduce((prev, next) => prev + next)}</b></td>
                  </tr>
                  </tbody>
              </table>
          </AssessmentInfoCard>


          <AssessmentInfoCard
              title={
                  <span style={{ color: "#eb4034", textTransform: "uppercase" }}>
                <b>Skill Will Matrix</b>
              </span>
              }
              smallTitle={""}>
              <table className="table">
                  <thead>
                  <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Will</th>
                      <th scope="col" className="tdHeaderGroup">RCL</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                  </tr>
                  </thead>
                  <tbody>
                  {userMatrixData.map((value, index) => (
                      <tr key={index}>
                          <td className="tdWhiteSpace">{value.matrixTitle}</td>
                          <td className="tdWhiteSpace">{value.supervisorOpinion}</td>
                          <td className="tdCenter">{value.willValue}</td>
                          <td className="tdCenter">{value.rca}</td>
                          <td className="tdCenter">{value.opinionValue}</td>
                      </tr>
                  ))}
                 <tr>
                  <td colSpan={3} className="tdCenter"><b>Total</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userMatrixData.length === 0 ? "": userMatrixData.map(item => Number(item.opinionValue)).reduce((prev, next) => prev + next)}</b></td>
                </tr>
                  </tbody>
              </table>
          </AssessmentInfoCard>

      </Layout>)
}

export default MarksSummary